import { gql } from '@apollo/client'
import type { Order } from '@ztechapps/common.contract'
import { useSubscription, type UseSubscriptionProps } from '@ztechapps/common.hook'
import { logisticFragment, singleLogisticQuery } from './graphql'

const defaultQuery = gql`
  ${logisticFragment}
  subscription updatedLogistic($filter: JSON) {
    updatedLogistic(filter: $filter) {
      ...logisticFragment
    }
  }
`

export type UseLogisticUpdatedSubscriptionProps = {
  logisticId: string
} & UseSubscriptionProps<{ updatedOrder: Order }>

export const useLogisticUpdatedSubscription = ({
  query,
  logisticId,
  filter,
  ...props
}: UseLogisticUpdatedSubscriptionProps) => {
  query ??= defaultQuery
  filter ??= {
    _id: logisticId,
  }

  return useSubscription<{ updatedOrder: Order }>({
    query,
    filter,
    cacheQuery: singleLogisticQuery,
    entityName: 'logistic',
    ...props,
  })
}
